module.exports = __webpack_public_path__ + "static/media/Noon Bulk Upload Templates.264e6436.xlsx";